// @flow
import Cookies from "js-cookie"

import { get } from "common/utils/get"
import type { WindowType } from "common/consts/windowConsts"
import { TYPES } from "common/consts/windowConsts"

type Banner = { showOnMobile: boolean }

export const hashBannerText = (text: string): string =>
  `${text[0]}_${text[parseInt(text.length / 5)]}_${text[parseInt(text.length / 2)]}_${
    text[text.length - 1]
  }}`

export const shouldShowAlert = (windowType: WindowType, banner: Banner): boolean =>
  !(windowType === TYPES.MOBILE && !banner.showOnMobile)

export const handleClosedBannerCookies = (index: number): void => {
  const cookiesClosedBanners = Cookies.getJSON("closedBanners") || []
  const state = window.reduxStore.getState()
  const closedBanner = hashBannerText(
    get(["remoteConfig", "bannersConfig", "banners", index, "text"], state),
  )
  Cookies.set("closedBanners", JSON.stringify([closedBanner].concat(cookiesClosedBanners)), {
    expires: 1,
  })
}
